import React from 'react';
import cls from 'classnames';
import './Tools.scss';

function Tool_counter({ num = 0, onChangeNum, onlyRemove }) {
  return (
    <div className="Tool Tool__counter">
      <a
        className="Tool__counter__btn minus"
        onClick={() => {
          let newVal = num - 1;
          newVal = newVal < 0 ? 0 : newVal;
          //console.log(newVal);
          onChangeNum(newVal);
        }}
      >
        {/* <i className='fas fa-minus' /> */}
        -
      </a>
      <span className="Tool__counter__txt">
        {num}
      </span>
      <a
        className={cls(
          'Tool__counter__btn plus',
          onlyRemove ? 'onlyRemove' : ''
        )}
        onClick={() => {
          if (!onlyRemove) {
            let result = num + 1;
            result = result >= 99 ? 99 : result;
            //console.log(result);
            // >= 99 ? 99 : num + 1;
            onChangeNum(result);
          }
        }}
      >
        {/* <i className='fas fa-plus' /> */}
        +
      </a>
    </div>
  );
}

export default Tool_counter;
